import { LS_LAST_MESSAGE_SENT_AT } from '../../common/constants/private';

export const getLastMessageSentAt = (): number | null => {
	const lastMessageSentAt = localStorage.getItem(LS_LAST_MESSAGE_SENT_AT);

	if (!lastMessageSentAt) {
		return null;
	}

	const timestamp = parseInt(lastMessageSentAt);

	if (isNaN(timestamp)) {
		return null;
	}

	return timestamp;
};

export const setLastMessageSentAt = (timestamp: number | null): void => {
	if (timestamp === null) {
		localStorage.removeItem(LS_LAST_MESSAGE_SENT_AT);
		return;
	}

	localStorage.setItem(LS_LAST_MESSAGE_SENT_AT, timestamp.toString());
};
